export default class OutletKeyConverter {
    constructor() {}

    replaceKey(outlet) {
        outlet.product_categories.forEach(category => {
            this.updateKey(category, 'desc', 'description');
            this.updateKey(category, 'seq', 'sequence');
        });

        outlet.products.forEach(product => {
            this.updateKey(product, 'desc', 'description');
            this.updateKey(product, 'seq', 'sequence');
            this.updateKey(product, 'c_id', 'category_id');
            this.updateKey(product, 'g_ct', 'grouped_ct');
            this.updateKey(product, 's_item', 'is_subscription_item');
        });

        outlet.product_sizes.forEach(size => {
            this.updateKey(size, 'desc', 'description');
            this.updateKey(size, 'seq', 'sequence');
            this.updateKey(size, 'p_id', 'product_id');
            this.updateKey(size, 's_item', 'is_subscription_item');
        });

        outlet.product_customization_types.forEach(pct => {
            this.updateKey(pct, 'desc', 'description');
            this.updateKey(pct, 'seq', 'sequence');
            this.updateKey(pct, 'ps_ids', 'product_size_ids');
        });

        outlet.product_customizations.forEach(pc => {
            this.updateKey(pc, 'desc', 'description');
            this.updateKey(pc, 'seq', 'sequence');
            this.updateKey(pc, 'pct_id', 'product_customization_type_id');
        });

        return outlet;
    }

    updateKey(obj, newKey, oldKey) {
        if (obj[newKey] !== undefined) {
            obj[oldKey] = obj[newKey];
            delete obj[newKey];
        }
    }
}
